import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import { useUserStore } from "../../../contexts/userStore";
import InterlockService from "../../../services/InterlockService";
import "./FormInterlocks.css";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { LuRouteOff } from "react-icons/lu";
import { InterlockAccessModulesDDL } from "../../../components/InterlockAccessModulesDDL/InterlockAccessModulesDDL";

function FormInterlocks(props) {
	const [name, setName] = useState(props.interlock?.name);
	const [enabled, setEnabled] = useState(props.interlock?.enabled ?? false);
	const [description, setDescription] = useState(
		props.interlock?.description
	);
	const { selectedCondominio, selectedLicenceId } = useUserStore();
	const [accessSelected, setAccessSelected] = useState(
		props.interlock?.accessModules
	);

	useEffect(() => {
		setName(props.interlock?.name);
		setEnabled(props.interlock?.enabled);
		setDescription(props.interlock?.description);
	}, [props.interlock]);

	const navigate = useNavigate();

	const buildPayload = () => {
		let payload = {
			id_condominium: parseInt(selectedCondominio),
			licence_id: selectedLicenceId,
			name,
			enabled,
			description,
			interlockAccessModules: accessSelected?.map(accessSelected => ({
				id: accessSelected.relationId ?? null,
				moduleId: accessSelected.originalId,
				accessIndex: accessSelected.subIndex,
			})) || [],
			uuid: uuidv4(),
		};
		return payload;
	};

	async function handleSubmit(event) {
		event.preventDefault();
		if (props.type === "edicao") {
			handleEdit(event);
			return;
		}
		const payload = buildPayload();
		const response = await InterlockService.createInterlock(payload);
		if (response.data.id) navigate("../consulta-interlocks", {
			state: { refresh: true }
		});
	}

	async function handleEdit(event) {
		event.preventDefault();
		const payload = buildPayload();
		const response = await InterlockService.updateInterlock(
			props.interlock.id,
			payload
		);
		if (response.data.id) navigate("../consulta-interlocks");
	}

	async function handleDelete() {
		if (!props.interlock) return;
		await InterlockService.deleteInterlock(props.interlock.id);
		navigate("../consulta-interlocks", {
			state: { deletedId: props.interlock.id },
		});
	}

	const handleClickEditButton = () => {
		if (!props.interlock) return;
		navigate(`/interlocks/${props.interlock.uuid}`, { state: props.interlock });
	};

	const handleChangeDualList = (accessSelectedArray) => {
		setAccessSelected(accessSelectedArray);
	};

	return (
		<>
			{!props.isTemp && (
				<FormTitle
					type={props.type}
					icon={<LuRouteOff size={20} />}
					tituloConsulta={props.interlock?.name || null}
					tituloCadastro="Cadastro de Intertravamento"
					backRoute={"/consulta-interlocks"}
				/>
			)}
			<Form
				handleSubmit={handleSubmit}
				type={props.type}
				handleClickEdit={handleClickEditButton}
				handleDelete={handleDelete}
				navigateCancelUrl="../consulta-interlocks"
				deleteButNotSynqed={props.interlock?.deletedAt ? true : false}
			>
				<div className="w-full grid grid-cols-1 gap-6">
					<div className="form-cond-container" style={{ width: '100%' }}>
						<div
							className={`container-name-direction ${props.type === "consulta" ? "consulta-mode" : ""
								}`}
						>
							<Input
								name="name"
								id="name"
								labelText="Nome *"
								value={name}
								onChange={({ target }) => { setName(target.value); }}
								disabled={props.type === "consulta"}
								required={true}
								tooltipText="Nome do intertravamento"
								tooltipVisible={true}
							/>

							<Input
								name="Descricao"
								id="descricao"
								labelText="Descrição"
								value={description}
								onChange={({ target }) => { setDescription(target.value); }}
								hidden={props.type === "consulta"}
								disabled={props.type === "consulta"}
								required={false}
								tooltipText="Descrição do intertravamento"
								tooltipVisible={true}
							/>
						</div>
						<div className='flex flex-row items-center gap-3.5 my-2'>
							<ToggleButton
								style={{ width: 'fit-content' }}
								label={`Habilitado`}
								onChange={(e) => setEnabled(e.target.checked)}
								disabled={props.type === "consulta"}
								selected={enabled}
							/>
						</div>
					</div>
					{props.type !== "consulta" && (
						<div className="container-dual-list-access-groups w-full!" style={{ display: "flex" }}>
							<div className="form-cond-dual-list-container w-full">
								<InterlockAccessModulesDDL
									onChangeList={handleChangeDualList}
									interlock={props.interlock}
								/>
							</div>
						</div>
					)}
				</div>
			</Form>
		</>
	);
}

export default FormInterlocks;
